var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_508_10113)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.0919 11.2756L41.7446 17.5323C38.6743 14.6389 34.5411 12.8623 30 12.8623C20.5512 12.8623 12.8625 20.551 12.8625 29.9999C12.8625 30.3808 12.8765 30.7593 12.9011 31.1343H16.6945C17.9613 31.1343 18.6387 32.6261 17.8066 33.58L14.5207 37.3488L9.08666 43.5832L7.57259 41.8464L0.366705 33.58C-0.466501 32.6261 0.212017 31.1343 1.47882 31.1343H4.67336C4.65696 30.7581 4.64758 30.3796 4.64758 29.9999C4.64758 23.2276 7.28431 16.8608 12.0726 12.0725C16.8609 7.28419 23.2277 4.64746 30 4.64746C36.3856 4.64746 42.4102 6.99356 47.0919 11.2756ZM58.5212 31.2034H55.3243C55.0314 37.5234 52.431 43.4226 47.9274 47.9273C43.1391 52.7156 36.7723 55.3523 30 55.3523C24.1711 55.3523 18.6433 53.3977 14.1621 49.7988L19.5105 43.5421C22.4121 45.7945 26.052 47.1375 30 47.1375C39.0446 47.1375 46.4743 40.0933 47.0942 31.2034H43.3055C42.0387 31.2034 41.3614 29.7128 42.1934 28.7577L46.138 24.2331L50.9134 18.7545L54.2591 22.5925L59.6333 28.7577C60.4666 29.7128 59.788 31.2034 58.5212 31.2034Z",
    fill: "#619CED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7446 17.5323C38.6743 14.6389 34.541 12.8623 30 12.8623V4.64746C36.3856 4.64746 42.4102 6.99356 47.0919 11.2756L41.7446 17.5323ZM58.5212 31.2034H55.3243C55.0313 37.5234 52.4309 43.4226 47.9274 47.9273C43.1391 52.7156 36.7723 55.3523 30 55.3523V47.1375C39.0446 47.1375 46.4743 40.0933 47.0942 31.2034H43.3055C42.0387 31.2034 41.3614 29.7128 42.1934 28.7577L46.138 24.2331L50.9134 18.7545L54.2591 22.5925L59.6333 28.7577C60.4665 29.7128 59.788 31.2034 58.5212 31.2034Z",
    fill: "#4773CC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_508_10113"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.8bf763017064546e34c40b395a553cb3.svg";
export { ForwardRef as ReactComponent };